const createWebsocket = (
  url: string,
  protocols?: string | string[]
): WebSocket => new WebSocket(url, protocols);

export { createWebsocket };
